export const initMsw = async () => {
  if ('ServiceWorker' in globalThis) {
    const { worker } = await import('../mocks/browser');
    worker.start({ onUnhandledRequest: 'bypass' });
  } else {
    const { server } = await import('../mocks/server');
    server.listen({ onUnhandledRequest: 'bypass' });
  }
};
